import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TabCollectPage } from './tab-collect.page';

const routes: Routes = [
  {
    path: '',
    component: TabCollectPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TabCollectPageRoutingModule {}
